<template>
  <el-col :span="24">
    <el-col :span="24" >
      <el-col :span="18" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
        <ComponentDatePicker ref="ComponentDatePicker"></ComponentDatePicker>
      </el-col>
      <el-col :span="6" style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
        <el-button type="danger" @click="ostentation_time">按时间查询</el-button>
        <el-button type="danger" @click="daochu">导出</el-button>
        <el-button type="primary" @click="add_information()">添加会员卡销售记录</el-button>
      </el-col>
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    "
    border
     style="width: 100%">
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column label="日期" prop="time">
        <template slot-scope="scope">
          {{ret_YearMonthDate(scope.row.time)}}
        </template>
      </el-table-column>
      <el-table-column label="会员号" prop="member_id"> </el-table-column>
      <el-table-column label="会员名" prop="member_name" ></el-table-column>
      <el-table-column label="电话" prop="phone" ></el-table-column>
      <el-table-column label="充值金额" prop="recharge_money" ></el-table-column>
      <el-table-column label="赠送金额" prop="give_money" ></el-table-column>
      <el-table-column label="办卡人" prop="card_holder" ></el-table-column>
      <el-table-column align="left" label="信息操作" width="250">
        <template slot-scope="scope" >
          <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="warning" @click="modify_information(scope.row)" >修改信息</el-button>
          <el-popconfirm
            title="确认删除？"
            @confirm="delete_information(scope.row)"
          >
            <el-button slot="reference" type="danger" v-show="scope.row.store_id==0">删除信息</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible" width="30%">
      <el-form  :model="form"  :label-width="formLabelWidth">
        <el-form-item label="时间:">
           <el-date-picker
                v-model="value1"
                type="date"
                placeholder="选择日期"
                value-format="timestamp">
              </el-date-picker>
        </el-form-item>
        <el-form-item label="会员号:">
          <el-input v-model="form.member_id" placeholder="请输入会员号"></el-input>
        </el-form-item>
        <el-form-item label="会员名:">
          <el-input v-model="form.member_name" placeholder="请输入会员名"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="充值金额:">
          <el-input v-model="form.recharge_money" placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item label="赠送金额:">
          <el-input v-model="form.give_money" placeholder="请输入赠送金额"></el-input>
        </el-form-item>
        <el-form-item label="办卡人:">
         <el-autocomplete
         class="inline-input"
         v-model="form.card_holder"
         :fetch-suggestions="querySearch"
           placeholder="请输入内容"
          ></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="startGame">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="dialogFormVisible_modify" width="30%">
      <el-form :model="form" :label-width="formLabelWidth">
        <el-form-item label="时间:">
           <el-date-picker
                v-model="value1"
                type="date"
                placeholder="选择日期"
                value-format="timestamp">
              </el-date-picker>
        </el-form-item>
        <el-form-item label="会员号:">
          <el-input v-model="form.member_id" placeholder="请输入会员号" :disabled='!(form.store_id==0)'></el-input>
        </el-form-item>
        <el-form-item label="会员名:">
          <el-input v-model="form.member_name" placeholder="请输入会员名"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="form.phone" placeholder="请输入手机号" :disabled='!(form.store_id==0)'></el-input>
        </el-form-item>
        <el-form-item label="充值金额:">
          <el-input v-model="form.recharge_money" placeholder="请输入充值金额" :disabled='!(form.store_id==0)'></el-input>
        </el-form-item>
        <el-form-item label="赠送金额:">
          <el-input v-model="form.give_money" placeholder="请输入赠送金额" :disabled='!(form.store_id==0)'></el-input>
        </el-form-item>
        <el-form-item label="办卡人:">
          <el-autocomplete
          class="inline-input"
          v-model="form.card_holder"
          :fetch-suggestions="querySearch"
            placeholder="请输入内容"
           ></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="startGame_modify">确 定</el-button>
      </div>
    </el-dialog>
  </el-col>
</template>

<script>
  import {
    protocol_ZgrShopOstentation_Membership_list,
    protocol_ZgrShopOstentationOrder_Membership_eidt,
    protocol_ZgrShopOstentationOrder_Membership_add,
    protocol_ZgrShopOstentationOrder_Membership_delete,
    protocol_data_ShopWaiter_get
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'

  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
      gUtilityExcel
    } from "@/assets/js/utility/UtilityExcel";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        modify_div:'',
        tableData: [],
        shop_game:[],
        search: '',
        dialogFormVisible: false,
        dialogFormVisible_modify:false,
        btnChangeEnable:false,
        form: {
          member_id:"",
          member_name:"",
          phone:"",
          recharge_money:"",
          give_money:"",
          card_holder:"",
          store_id:0
        },
        formLabelWidth: '120px',
        value1:'',
        ShopWaiter:[],
      }
    },
    methods: {
      get_waiter_data(){
          let _this=this;
          _this.ShopWaiter=[];
          protocol_data_ShopWaiter_get().then((res1)=>{
            for(let i=0;i<res1.ret.length;i++){
             for (var i = 0; i < res1.ret.length; i++) {
               _this.ShopWaiter[i] = {"value" :res1.ret[i].shop_waiter };
             }
            }
          })
      },
     querySearch(queryString, cb) {
       var restaurants =JSON.parse(JSON.stringify(this.ShopWaiter));
       var item = [];
       if(queryString!=""&&queryString!=null)
       {
         for (var i = 0; i < restaurants.length; i++) {
          if(queryString==restaurants[i].value)
          {
           continue;
          }
           item.push(restaurants[i])
         }
         for (var i = 0; i < item.length; i++) {
           item[i].value = `${queryString};${item[i].value}`;
         }
       }
       else{
          item=restaurants;
       }
       cb(item);
     },
      //按时间查询
      ostentation_time(){
        this.init_list(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start())/1000,gUtilityTime.endTime(this.$refs.ComponentDatePicker.get_time_end())/1000)
      },
      //添加信息
      add_information(){
        this.dialogFormVisible = true;
        this.value1 =new Date;
        this.form.member_id ='';
        this.form.member_name ='';
        this.form.phone ='';
        this.form.recharge_money ='';
        this.form.give_money ='';
        this.form.card_holder ='';
        this.modify_div='';
        this.form.store_id=0
      },
      // 删除信息
      delete_information(row){
        let _this=this;
        protocol_ZgrShopOstentationOrder_Membership_delete(row.id).then(res=>{
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
           _this.init_list();
        })
      },
      game_name(id){
        return gGameData.getDataByID(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      // 修改信息
      modify_information(row){
        this.dialogFormVisible_modify = true;
        this.value1 =row.time*1000;
        this.form.member_id =row.member_id;
        this.form.member_name =row.member_name;
        this.form.phone =row.phone;
        this.form.recharge_money =row.recharge_money;
        this.form.give_money =row.give_money;
        this.form.card_holder =row.card_holder;
        this.modify_div=row;
        this.form.store_id=row.store_id;
      },
      //修改提交
      startGame_modify(row){
        var _this = this;
        if(this.form.member_id==''){
          this.$message({
            message: '会员号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.member_name==''){
          this.$message({
            message: '会员名不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.phone==''){
          this.$message({
            message: '手机号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.recharge_money==''){
          this.$message({
            message: '充值金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.give_money==''){
          this.$message({
            message: '赠送金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.card_holder==''){
          this.$message({
            message: '办卡人不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Membership_eidt(
        parseInt(new Date(this.value1).getTime()/1000),
        this.form.member_id,
        this.form.member_name,
        this.form.phone,
        this.form.recharge_money,
        this.form.give_money,
        this.form.card_holder,
        this.modify_div.id
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '修改成功',
              type: 'success'
            });
            _this.dialogFormVisible_modify=false;
            _this.init_list();
          }
        })
      },
      daochu(){
        let title=`序号,日期,会员号,会员名,电话,充值金额,赠送金额,办卡人\n`;
        let data=[];
        for(let i=0;i<this.tableData.length;i++){
          let obj=Object();
          obj.index=(i+1);
          obj.time_start=this.tableData[i].time_year+"-"+this.tableData[i].time_month+"-"+this.tableData[i].time_day;
          obj.member_id=this.tableData[i].member_id;
          obj.member_name=this.tableData[i].member_name;
          obj.phone=this.tableData[i].phone;
          obj.recharge_money=this.tableData[i].recharge_money;
          obj.give_money=this.tableData[i].give_money;
          obj.card_holder=this.tableData[i].card_holder;
          data.push(obj)
        }
        gUtilityExcel.download_excel("会员卡销售数据.xls",title,data)
      },
      //提交
      startGame() {
        var _this = this;
        if(this.form.member_id==''){
          this.$message({
            message: '会员号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.member_name==''){
          this.$message({
            message: '会员名不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.phone==''){
          this.$message({
            message: '手机号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.recharge_money==''){
          this.$message({
            message: '充值金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.give_money==''){
          this.$message({
            message: '赠送金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.card_holder==''){
          this.$message({
            message: '办卡人不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Membership_add(
        parseInt(new Date(this.value1).getTime()/1000),
        this.form.member_id,
        this.form.member_name,
        this.form.phone,
        this.form.recharge_money,
        this.form.give_money,
        this.form.card_holder
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '添加成功',
              type: 'success'
            });
            _this.dialogFormVisible=false;
            _this.init_list();
          }
        })
      },
      //关闭弹窗
      cannelStartGame() {
        this.dialogFormVisible = false;
        this.dialogFormVisible_modify = false;
      },
      init_list(time_start,time_end){
        let _this=this;
        let date=new Date();
        if(time_start==undefined){
          time_start=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),1);
          time_end=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),2);
        }
        protocol_ZgrShopOstentation_Membership_list(time_start,time_end).then(res=>{
          _this.tableData=res.ret;
        })
      }
    },
    mounted() {
      this.DaySafter_list=gUtilityTime.DaySafter7();
      this.radio1=this.DaySafter_list[0];
      this.shop_game = gGameData.getAllDataShopData();
      this.init_list();
      this.get_waiter_data();
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Membership.vue